import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';
import {ContactValidationEditComponent} from '../../components/Editors/ContactValidationEdit.component';


@Component({
  selector: 'my-contact-validation-grid',
  templateUrl: './ContactValidationGrid.component.html'
})
export class ContactValidationGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(ContactValidationEditComponent) recordEditComponent: ContactValidationEditComponent;

    records: ent.ContactValidation[];
    editedRecord: ent.ContactValidation;
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private domainDataService: serv.DomainDataService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        
        this.editedRecord = new ent.ContactValidation();
        this.loadColumns();
        this.onSearchClick(null);
    }

    ngAfterViewInit() {
        this.recordEditComponent.validationTypeDropdownComponent.load();
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'ValidationType.Name', header: 'Type' },
            { field: 'Value', header: 'Value' },
            { field: 'Inactive', header: 'Inactive' }
        ];

    }

    onAddClick(event: any){
        this.editedRecord = new ent.ContactValidation();
        this.recordEditComponent.validationTypeDropdownComponent.value = null;
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, record: ent.ContactValidation){
        this.editedRecord = record;
        this.recordEditComponent.validationTypeDropdownComponent.value = record.ValidationTypeID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveContactValidationRequest = {ContactValidation: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveContactValidation(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.ContactValidationFilter = {IncludeInactive: true};
        this.domainDataService.getContactValidations(filter).subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        });
    }
}